import {
  Abc,
  AccountCircleOutlined,
  Add,
  AddBox,
  AddPhotoAlternate,
  AirportShuttle,
  Apps,
  Architecture,
  Assignment,
  Business,
  CalendarMonth,
  CarRepair,
  Chair,
  CheckCircle,
  Checkroom,
  Close,
  CloudDownload,
  CloudUpload,
  CreditScore,
  Dashboard,
  DeleteForever,
  Description,
  Desk,
  DoDisturbOn,
  Domain,
  DomainAddOutlined,
  EditNote,
  EnhancedEncryption,
  Error,
  EventAvailable,
  ExitToApp,
  Feed,
  FileOpen,
  FileDownload,
  Garage,
  GridView,
  Help,
  History,
  Home,
  HomeWork,
  Image,
  Inventory,
  ListAlt,
  ManageAccounts,
  MonetizationOn,
  MoveDown,
  Notifications,
  People,
  Person,
  PersonAdd,
  Place,
  QrCode,
  QueryStats,
  Remove,
  RemoveCircle,
  RemoveRounded,
  RequestQuote,
  Schedule,
  Search,
  Send,
  Settings,
  SettingsSuggest,
  SettingsSystemDaydream,
  SpeakerNotes,
  SwapHoriz,
  SyncAlt,
  TextIncrease,
  Traffic,
  Update,
  UploadFile,
  VerticalAlignBottom,
  ViewList,
  Visibility,
  Warehouse,
  Work,
  List,
  Assessment,
  BarChart,
  Info,
  HelpOutline,
  Print,
  PictureAsPdf,
  SaveAlt,
  LibraryAdd,
  AccountBalance,
  AccountBalanceWallet,
  CorporateFare,
  Handshake,
  AttachMoney,
  Calculate,
  Gavel,
  LockOpen,
  ArrowCircleUp,
  ArrowCircleDown

} from "@mui/icons-material";

export const Icons = (icon: string) => {
  switch (icon) {
    case "Home":
      return <Home />;
    case "SaveAlt":
      return <SaveAlt />;
    case "History":
      return <History />;
    case "LibraryAdd":
      return <LibraryAdd />;
    case "HomeWork":
      return <HomeWork />;
    case "RequestQuote":
      return <RequestQuote />;
    case "CreditScore":
      return <CreditScore />;
    case "Architecture":
      return <Architecture />;
    case "SwapHoriz":
      return <SwapHoriz />;
    case "Domain":
      return <Domain />;
    case "EditNote":
      return <EditNote />;
    case "Remove":
      return <Remove />;
    case "RemoveRounded":
      return <RemoveRounded />;
    case "ManageAccounts":
      return <ManageAccounts />;
    case "AddPhotoAlternate":
      return <AddPhotoAlternate />;
    case "Warehouse":
      return <Warehouse />;
    case "Chair":
      return <Chair />;
    case "Add":
      return <Add />;
    case "AirportShuttle":
      return <AirportShuttle />;
    case "Checkroom":
      return <Checkroom />;
    case "SyncAlt":
      return <SyncAlt />;
    case "DomainAddOutlined":
      return <DomainAddOutlined />;
    case "Update":
      return <Update />;
    case "Desk":
      return <Desk />;
    case "EnhancedEncryption":
      return <EnhancedEncryption />;
    case "TextIncrease":
      return <TextIncrease />;
    case "Traffic":
      return <Traffic />;
    case "Apps":
      return <Apps />;
    case "Assignment":
      return <Assignment />;
    case "Inventory":
      return <Inventory />;
    case "Garage":
      return <Garage />;
    case "Feed":
      return <Feed />;
    case "GridView":
      return <GridView />;
    case "ViewList":
      return <ViewList />;
    case "Person":
      return <Person />;
    case "AccountCircleOutlined":
      return <AccountCircleOutlined />;
    case "People":
      return <People />;
    case "Abc":
      return <Abc />;
    case "CloudUpload":
      return <CloudUpload />;
    case "CloudDownload":
      return <CloudDownload />;
    case "Schedule":
      return <Schedule />;
    case "Notifications":
      return <Notifications />;
    case "SettingsSystemDaydream":
      return <SettingsSystemDaydream />;
    case "SettingsSuggest":
      return <SettingsSuggest />;
    case "MonetizationOn":
      return <MonetizationOn />;
    case "MoveDown":
      return <MoveDown />;
    case "CarRepair":
      return <CarRepair />;
    case "SpeakerNotes":
      return <SpeakerNotes />;
    case "Business":
      return <Business />;
    case "Place":
      return <Place />;
    case "DeleteForever":
      return <DeleteForever />;
    case "AddBox":
      return (
        <AddBox
          style={{
            fontSize: "large",
            width: "35px",
            height: "35px",
          }}
        />
      );
    case "Description":
      return <Description />;
    case "QueryStats":
      return <QueryStats />;
    case "Search":
      return <Search />;
    case "UploadFile":
      return <UploadFile />;
    case "Error":
      return <Error style={{ color: "red" }} />;
    case "CheckCircle":
      return <CheckCircle style={{ color: "green" }} />;
    case "DoDisturbOn":
      return <DoDisturbOn style={{ color: "orange" }} />;
    case "RemoveCircle":
      return <RemoveCircle style={{ color: "orange" }} />;
    case "ListAlt":
      return <ListAlt />;
    case "Dashboard":
      return <Dashboard />;
    case "Work":
      return <Work />;

    case "QrCode":
      return <QrCode />;
    case "FileOpen":
      return <FileOpen />;
    case "Settings":
      return <Settings />;
    case "Help":
      return <Help />;
    case "ExitToApp":
      return <ExitToApp />;
    case "CalendarMonth":
      return <CalendarMonth />;
    case "EventAvailable":
      return <EventAvailable />;
    case "Send":
      return <Send />;
    case "PersonAdd":
      return <PersonAdd />;
    case "VerticalAlignBottom":
      return (
        <VerticalAlignBottom
          style={{
            fontSize: "large",
            width: "20px",
            height: "20px",
            padding: "0px",
            margin: "0px",
          }}
        />
      );
    case "Picture":
      return <Image />;
    case "Visibility":
      return <Visibility />;
    case "Close":
      return <Close />;
    case "FileDownload":
      return <FileDownload />;
    case "List":
      return <List />;
    case "Assessment":
      return <Assessment />;
    case "BarChart":
      return <BarChart />;
    case "Info":
      return <Info />;
    case "HelpOutline":
      return <HelpOutline />;
    case "Print":
      return <Print />;
    case "PictureAsPdf":
      return <PictureAsPdf />;
    case "AccountBalance":
      return <AccountBalance />;
    case "AccountBalanceWallet":
      return <AccountBalanceWallet />;
    case "AttachMoney":
      return <AttachMoney />;
    case "CorporateFare":
      return <CorporateFare />;
    case "Handshake":
      return <Handshake />;
    case "Calculate":
      return <Calculate />;
    case "Gavel":
      return <Gavel />;
    case "LockOpen":
      return <LockOpen />;
    case "ArrowCircleUpIcon":
      return <ArrowCircleUp />;
    case "ArrowCircleDownIcon ":
      return <ArrowCircleDown />;
    default:
      return <Help />;
  }
};
